// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mTQfSsRI9ztQd8 {
  padding-bottom: var(--ds-space-150, 12px);
}
.pop-over-content .mTQfSsRI9ztQd8 {
  padding-bottom: var(--ds-space-0, 0);
}
.MPFuF4aEl88EaQ {
  top: var(--ds-space-0, 0);
  right: var(--ds-space-0, 0);
  padding: var(--ds-space-150, 10px) var(--ds-space-150, 12px) var(--ds-space-150, 10px) var(--ds-space-100, 8px);
  position: absolute;
  z-index: 2;
}
.MPFuF4aEl88EaQ:hover {
  filter: brightness(75%);
}
._4EG3YV8lVAipX {
  top: var(--ds-space-0, 0);
  left: var(--ds-space-0, 0);
  padding: var(--ds-space-150, 10px) var(--ds-space-100, 8px) var(--ds-space-150, 10px) var(--ds-space-150, 12px);
  position: absolute;
  z-index: 2;
}
._4EG3YV8lVAipX:hover {
  filter: brightness(75%);
}
.wF7WBFJV8tn3tE {
  display: block;
  position: relative;
  z-index: 1;
  box-sizing: border-box;
  margin: var(--ds-space-0, 0) var(--ds-space-0, 0) var(--ds-space-075, 6px) var(--ds-space-0, 0);
  padding: var(--ds-space-0, 0) var(--ds-space-400, 32px);
  overflow: hidden;
  border-bottom: 1px solid var(--ds-border, #091e4224);
  color: var(--ds-text-subtle, #44546f);
  line-height: 40px;
  text-align: center;
  text-overflow: ellipsis;
  white-space: nowrap;
}
`, ""]);
// Exports
export var wrapper = `mTQfSsRI9ztQd8`;
export var closeButton = `MPFuF4aEl88EaQ`;
export var backButton = `_4EG3YV8lVAipX`;
export var title = `wF7WBFJV8tn3tE`;
export default ___CSS_LOADER_EXPORT___;
